export default __webpack_public_path__ + "static/media/undraw_Taken_re_yn20.a9efc9c0.svg";